import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllContest = createAsyncThunk(
  "student/allContest",
  async ({ page, limit, filter, searchData }, { rejectWithValue }) => {
    try {
      let url = `/contest/all?page=${page}&limit=${limit}`;
      if (filter) {
        url += `&contestFilter=${filter}`;
      }
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const initialState = {
  contestData: [],
};

const contestSlice = createSlice({
  name: "contestSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllContest.fulfilled, (state, action) => {
      state.contestData = action.payload.data;
    });
  },
});
export default contestSlice.reducer;
